export const mergeColumnsWithCurrentState = (
  currentColumns: any[],
  nextColumns: any[],
) => {
  const currentStateByDataIndex = new Map(
    currentColumns.map((column: any) => [
      column.dataIndex,
      {
        hidden: column.hidden,
        fixed: column.fixed,
      },
    ]),
  );

  return nextColumns.map((column: any) => {
    const currentState = currentStateByDataIndex.get(column.dataIndex);

    if (!currentState) {
      return column;
    }

    return {
      ...column,
      hidden: currentState.hidden,
      fixed: currentState.fixed,
    };
  });
};

export const updateColumnDisplayState = (
  columns: any[] = [],
  dataIndex: string,
  value: boolean | "left" | "right",
  type: "hidden" | "fixed",
  getColumnKey: (column: any) => any = (column) => column.dataIndex,
) =>
  columns.map((column: any) =>
    getColumnKey(column) === dataIndex
      ? { ...column, [type]: type === "hidden" ? !value : value }
      : column,
  );
